import React from 'react'

const TimeIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='90' height='90' viewBox='0 0 90 90'><g><g><path fill='#415055' d='M45 90C20.147 90 0 69.853 0 45S20.147 0 45 0s45 20.147 45 45-20.147 45-45 45zm3-83.874V15h-6V6.126C22.855 7.584 7.583 22.856 6.125 42H15v6H6.125C7.583 67.143 22.855 82.416 42 83.874V75h6v8.874C67.145 82.416 82.417 67.144 83.875 48H74v-6h9.875C82.417 22.857 67.145 7.584 48 6.126zm.52 40.117l-3.444 4.913-21.09-14.785 3.444-4.913 16.032 11.24L60.19 18.55l4.896 3.485-16.705 24.112z' /></g></g></svg>
)

export default TimeIcon
